export default "__VITE_ASSET__8uYeGveY__"